import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import Loading from "../Component/Loding.jsx";
import moment from "moment";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';
import { createPopup } from "../../Common/common.js"

import * as Common from "../../Common/common.js";

import mainBg from "../../assets/img/bg-busuness-03.jpg";
import aiImg from "../../assets/img/ai-WISvision.png";
import aiIcon01 from "../../assets/img/icon-ai24.png";
import aiIcon02 from "../../assets/img/icon-ai26.png";
import aiIcon03 from "../../assets/img/icon-ai27.png";
import aiIcon04 from "../../assets/img/icon-ai23.png";
import fwImg from "../../assets/img/fw-wisvision.png";

function Inquiry() {

  // 권한 체크
      const authCk = Common.fn_authChek();

    // 화면 이동을 위한 네비게이터 설정
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

  // 일반 또는 관리자 header 설정
  const { argInfo } = useContext(ArgContext);
  const isAdmin = argInfo?.role === 'admin';

      //유효성
      const [emailInfo, setEmailInfo] = useState({
            gubun: "qna"
          , registDate: ""
          , registName: ""
          , registMail: ""
          , registTitle: ""				// 검증 체크에러 방지용..
          , registContent: ""			// 검증 체크에러 방지용..
          , registTelNo: ""
          , registTelNo2: ""
          , registRequire: ""
          , agreeChk: ""
      });
  
          // 파일 정보 제외한 data 변경 값 set
          const handleChange = (e) => {
          const { value, name, checked } = e.target;
          
          if (name == 'agreeChk') {
			setEmailInfo({
			  ...emailInfo, // 기존 객체 복사
			  [name]: checked, // name 키를 가진 값을 value로 설정
			});
		  } else {
			setEmailInfo({
			  ...emailInfo, // 기존 객체 복사
			  [name]: value, // name 키를 가진 값을 value로 설정
			});
		  }
        }
/*
          const handleSuccess = () => {
              const title = '접수 완료';
              const cont = '4주 이내에 확인 및 조치하여<br />결과를 회신드리겠습니다.';
              createPopup(title,cont);
              //setShowPopup(true);
              setIsLoading(false);
          };
*/      
        //문의하기
        const fn_report = () => {
          setIsLoading(true);
          Common.fn_send([], emailInfo, "/Inquiry", setIsLoading)
                  .then(response => {
                      //console.log('Success:', response);
                      //handleSuccess();
                      setIsLoading(false);
                      window.location.href = "/Inquiry"
                  })
                  .catch(error => {
                      //console.error('Error:', error);
                      setIsLoading(false);
                  });
        }

      //파일다운로드
      const downloadFile = async () => {
        try {
          const response = await fetch("/download/brochure");
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const blob = await response.blob();
        
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "위피아_AI솔루션.pdf";
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('Download failed:', error);
          alert('파일 다운로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
        }
      };
  
    return (<>
  <main className="page-wrapper">
    {isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
      <section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
          <div className="textBox">
            <h2>제품 문의하기</h2>
            <p>위피아 홈페이지 방문 후 문의사항이 있으시면 담당자 확인 후 신속히 안내해 드리겠습니다.</p>
          </div>
          <SubMenu />
      </section>

      <section className="container-auto sec-my inquiry-wrap">
        <h3 className="sub-title">제품 문의하기</h3>
        <p className="sub-text">위피아 홈페이지 방문 후 문의사항이 있으시면 담당자 확인 후 신속히 안내해 드리겠습니다.</p>

        <div className="tableWrap">
							<form className="needs-validation" noValidate>
								<div className="tableBox">
                  <div className="list-ly01">
										<p className="title">회사명</p>
										<div className="text"><input type="text" name="registDate" onChange={handleChange} required/></div>
									</div>
									<div className="list-ly02">
										<p className="title">담당자명</p>
										<div className="text"><input type="text" name="registName" onChange={handleChange} required/></div>
                    <p className="title">이메일</p>
										<div className="text"><input type="text" name="registMail" onChange={handleChange} required/></div>
									</div>

									<div className="list-ly02">
										<p className="title">휴대전화번호</p>
										<div className="text"><input type="text" name="registTelNo" onChange={handleChange}/></div>
                    <p className="title">회사전화번호</p>
										<div className="text"><input type="text" name="registTelNo2" onChange={handleChange}/></div>
									</div>
									<div className="list-ly01">
										<p className="title">요청사항</p>
										<div className="text"><textarea type="text" name="registRequire" onChange={handleChange} required /></div>
									</div>
								</div>

                <div className="agreement-wrap">
                  <div className="agree-text">
                      <p>위피아에서는 '정보통신망 이용촉진 및 정보보호'에 관한 법률을 준수하고 있습니다</p>
                      <ul className="list">
                        <li>
                          <p className="tit">온라인에서 수집하는 개인정보 항목 :</p>
                          <p className="txt">이름, 회사명, 부서, 직책, 회사전화, 이메일, 문의 내용</p>
                        </li>
                        <li>
                          <p className="tit">개인정보의 수집 및 이용목적 :</p>
                          <p className="txt">고객의 온라인 상담 및 문의에 대한 답신 및 요청 서비스 제공</p>
                        </li>
                        <li>
                          <p className="tit">개인정보의 보유 및 이용기간 :</p>
                          <p className="txt">이용목적 달성 때 까지 이용하며, 해당 개인정보 항목 및 답변 내역은 고객관리 차원에서 1년 보유 (별도 요청 시 즉시 삭제 처리)</p>
                        </li>
                        <li>
                          <p className="tit">개인정보 제공 :</p>
                          <p className="txt">수집된 이용자의 개인정보는 제3자에 제공하지 않음</p>
                        </li>
                      </ul>
                  </div>
                  <label htmlFor="agreeChk"><input type="checkbox" name="agreeChk" onChange={handleChange} id="agreeChk" />개인정보 수집 및 이용에 동의합니다.</label>
                </div>
								
                <ul className="btnWrap">
                  {/* <button type="button" className="submit-btn" onClick={()=>{fn_report()}}>신고하기</button> */}
                  <li>
                   <button type="button" className="submit-btn" onClick={()=>{fn_report()}}>문의하기</button>
                  </li>
                  <li>
                    <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
                  </li>
                </ul>
								
							</form>
						</div>
        
        
      </section>
    </main>
  <Footer />
	<Loading active={isLoading}/>
        </>
    )
}

export default Inquiry;